<template>
  <div>
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <!-- SETA OS DADOS DA TELA -->
    <div v-else class="dem-rel-mais-uti">
      <div class="app-fil-rel-nov">
        <table>
          <tr class="n-col-2">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'select'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome' ]"
              :cpntNome="'Status'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.dem_sta"

              :cpntOnBuscarOptions="demRelPorItensBuscarDemandaStatus"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'dem_sta') }"
              ref="dem_sta"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'seletor-data'"
              :cpntNome="''"
              :cpntTodos="'Todas as datas'"
              :cpntValue="filtros.dat"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'dat') }"
              ref="dat"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table>
          <tr :class="'n-col-' + demRelPorItensContarColunasLinha1">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Documento', chave: 'cnpj_cpf' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]"
              :cpntNome="'Contatos'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.con"
              :cpntNenhum="false"

              :cpntRouter="'/contato/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, empresa: null, cnpj_cpf: null }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'con') }"
              ref="con"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.vei === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Placa', chave: 'placa' }, { nome: 'Marca', chave: 'id_mar_nome' }, { nome: 'Modelo', chave: 'id_mod_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'demandaId_id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ]"
              :cpntNome="'Veículo'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.vei"
              :cpntNenhum="true"

              :cpntRouter="'/veiculo/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, placa: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'vei') }"
              ref="vei"
              ></App-Filtro-Relatorio>
            </td>
            <td v-if="permissoes.pet === true">
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' }, { nome: 'Raça', chave: 'id_pet_subespecie_nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'demandaId_id_con_nome' ]"
              :cpntNome="'Pet'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pet"
              :cpntNenhum="true"

              :cpntRouter="'/pet/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_con: { a: 'demandaId_id_con', j: { nome: { a: 'demandaId_id_con_nome' }, empresa: { a: 'demandaId_id_con_empresa' }, pessoa: { a: 'demandaId_id_con_pessoa' }, status: { a: 'demandaId_id_con_status' } } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }"
              :cpntWhere="{ aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'pet') }"
              ref="pet"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.pro === true">
          <tr :class="'n-col-3'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_cat"
              :cpntNenhum="false"

              :cpntRouter="'/produto/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'pro_cat') }"
              ref="pro_cat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Marca Produto'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.pro_mar"
              :cpntNenhum="false"

              :cpntRouter="'/produto/marca/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'pro_mar') }"
              ref="pro_mar"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'codigo' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ]"
              :cpntNome="'Produto'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.pro"
              :cpntNenhum="true"

              :cpntRouter="'/produto/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } }"
              :cpntWhere="() => { return demRelPorItensMontarWhereFiltro('pro') }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'pro') }"
              ref="pro"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>

        <table v-if="permissoes.ser === true">
          <tr :class="'n-col-3'">
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome']"
              :cpntNome="'Categoria Serviço'"
              :cpntTodos="'Todas'"
              :cpntValue="filtros.ser_cat"
              :cpntNenhum="false"

              :cpntRouter="'/servico/categoria/get/'"
              :cpntMethod="'GET'"
              :cpntField="{ id: null, nome: null }"
              :cpntWhere="{ aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'ser_cat') }"
              ref="ser_cat"
              ></App-Filtro-Relatorio>
            </td>
            <td>
              <App-Filtro-Relatorio
              :cpntTipo="'autocomplite'"
              :cpntTabela="[ { nome: 'Código', chave: 'id' }, { nome: 'Nome', chave: 'nome' } ]"
              :cpntKeyValue="'id'"
              :cpntKeyMostra="[ 'nome', ' - ', 'id_cat_nome', ' - ', 'id' ]"
              :cpntNome="'Serviço'"
              :cpntTodos="'Todos'"
              :cpntValue="filtros.ser"
              :cpntNenhum="true"

              :cpntRouter="'/servico/get'"
              :cpntMethod="'POST'"
              :cpntField="{ id: null, nome: null, id_cat: { j: { nome: null } } }"
              :cpntWhere="() => { return demRelPorItensMontarWhereFiltro('ser') }"
              @UPDATE_VALUE_FILTRO="(value) => { demRelPorItensAtualizarFiltro(value, 'ser') }"
              ref="ser"
              ></App-Filtro-Relatorio>
            </td>
          </tr>
        </table>
      </div>
      
      <div class="dem-rel-mais-uti-botao">
        <!-- SETA O BOTÃO PESQUISAR -->
        <App-Button :cpntStatus="pesquisa === 'carregando' ? pesquisa: ''" :cpntClass="'btn btn-primary'" @onClick="() => { demRelPorItensPesquisar() }">Pesquisar</App-Button>

        <!-- SETA O BOTÃO MINHA PERSONALIZAÇÃO -->
        <App-Minha-Personalizacao v-if="[ '', null, undefined ].indexOf(mper.tabper) === -1 && pesquisa !== null && pesquisa !== 'carregando'"
        :cpntMper='mper.tabper'
        :cpntMperRpp='mper.rpp'
        :cpntMperOrder='mper.order'
        :cpntMperOrderOptions='mper.orderOptions'
        :cpntMperField='mper.field'
        :cpntMperFieldOptions='mper.fieldOptions'
        :cpntMperFiltro='mper.filtro'

        @UPDATE='() => { demRelPorItensPesquisar() }'
        ></App-Minha-Personalizacao>
      </div>

      <div class="dem-rel-mais-uti-res" v-if="pesquisa !== null && pesquisa !== 'carregando'">
        <div v-if="grafico !== null" class="grafico">
          <!-- SETA O LOCAL DO GRAFICO -->
          <div v-if="demRelMaisUtiQtdeRegistro >= params.limitG" style="text-align: center; background: #e9e9e9; border: 1px solid #ccc; border-radius: 10px; padding: 40px 10px; width: 60%; margin: 0px auto;">
            OPS: O gráfico só pode ser gerado para quantidade de registros inferior a 3.000 (Utilize mais filtros). 
          </div>
          <template v-else-if="demRelMaisUtiQtdeRegistro > 0">
            <!-- SETA A ESCOLHA DO TIPO DO GRAFICO -->
            <App-Select :data-time="time" :class="campos.tp_grafico.class"
            :cpntStatus='campos.tp_grafico.status'
            :cpntId='campos.tp_grafico.id'
            :cpntTabIndex='campos.tp_grafico.tabIndex'
            :cpntNome='campos.tp_grafico.nome'
            :cpntValue='campos.tp_grafico.value'
            :cpntMensagem='campos.tp_grafico.mensagem'
            :cpntMensagemTipo='campos.tp_grafico.mensagemTipo'
            :cpntDisabled='campos.tp_grafico.disabled'
            :cpntMostrar='campos.tp_grafico.mostrar'
            :cpntExplica='campos.tp_grafico.explica'
            :cpntPlaceholder='campos.tp_grafico.placeholder'
            :cpntValueRef='campos.tp_grafico.valueRef'
            :cpntRouter='campos.tp_grafico.router'
            :cpntMethod='campos.tp_grafico.method'
            :cpntField='campos.tp_grafico.field'
            :cpntWhere='campos.tp_grafico.where'
            :cpntAddButForm='campos.tp_grafico.addButForm'
            :cpntKeyMostra='campos.tp_grafico.keyMostra'
            :cpntTipoOrder='campos.tp_grafico.tipoOrder'
            :cpntOrder='campos.tp_grafico.order'
            :cpntOptions='campos.tp_grafico.options'
            :cpntKeyValue='campos.tp_grafico.keyValue'
            :cpntSearchMinimo='campos.tp_grafico.searchMinimo'
            :cpntMask='campos.tp_grafico.mask'
            :cpntOptionInicialNome='campos.tp_grafico.optionInicialNome'
            :cpntOptionInicialValue='campos.tp_grafico.optionInicialValue'

            :cpntOnChange='campos.tp_grafico.onChange'
            ref="tp_grafico"
            ></App-Select>
            
            <div style="width: 100%; max-width: 98%; overflow-x: auto;">
              <div :style="'width: ' + tamanho + ';'">
                <canvas ref="grafico" style="position: relative; z-index: 1; width: 100%;"></canvas>
              </div>
            </div>
          </template>
        </div>

        <!-- NENHUM REGISTRO -->
        <div v-if="pesquisa.produto === undefined && pesquisa.servico === undefined" class="nenhum-reg">
          Nenhum registro encontrado.
        </div>

        <!-- VERIFICA SE TEM PRODUTO -->
        <template v-if="pesquisa.produto !== undefined">
          <!-- TOTAIS -->
          <div class="totais" v-if="pesquisa.produto.totais !== null && demRelMaisUtiQtdeRegistro > 0">
            <div style="text-align: right;">
              <App-Explica :cpntTitle='"Abaixo a soma dos valores de todas as página"'></App-Explica>
            </div>

            <div class="valores">
              <div class="custo">
                Qtde Total:
                <br/>
                <span><span v-html="pesquisa.produto.totais._qtde"></span></span>
              </div>
              <div class="venda">
                Valor Total:
                <br/>
                <span>R$ <span v-html="pesquisa.produto.totais._total"></span></span>
              </div>
              <div class="venda" :class="pesquisa.produto.totais.ticket_medio > 0 ? 'lucro' : (pesquisa.produto.totais.ticket_medio < 0 ? 'custo' : '')">
                Ticket Médio:
                <br/>
                <span>R$ <span v-html="pesquisa.produto.totais._ticket_medio"></span></span>
              </div>
            </div>
          </div>

          <!-- SETA OS DADOS DOS PRODUTOS -->
          <App-Demanda-Relatorio-Por-Itens-Tabela
          :cpntDemanda="cpntDemanda + '_produto'"
          :cpntApiTabPer="mper.tabper"
          :cpntApiTabPerOrder="mper.orderOptions"
          :cpntLinhas="pesquisa.produto.linhas"
          :cpntColunas="mper.fieldOptions"
          :cpntTotais="pesquisa.produto.totais"
          :cpntTotal="pesquisa.produto.countAll"
          :cpntMontarRouter="demRelPorItensMontarRouter"
          :cpntMontarMethod="demRelPorItensMontarMethod"
          :cpntTratarLinhas="demRelMaisUtiTaTratarLinhas"
          :cpntBotaoExportar="exportar"
          :cpntApiMontarQueryGet="(pag, rpp) => { return demRelPorItensMontarQueryGet(pag, rpp, 'produto') }"
          :cpntFiltros="filtros"
          :cpntRpp="Number(tabper.rpp)"

          @UPDATE_TOTAIS="(value) => { demRelPorItensSetarTotais(value) }"
          ></App-Demanda-Relatorio-Por-Itens-Tabela>
        </template>

        <!-- VERIFICA SE TEM SERVIÇO -->
        <template v-if="pesquisa.servico !== undefined">
          <!-- TOTAIS -->
          <div class="totais" v-if="pesquisa.servico.totais !== null">
            <div style="text-align: right;">
              <App-Explica :cpntTitle='"Abaixo a soma dos valores de todas as página"'></App-Explica>
            </div>

            <div class="valores">
              <div class="custo">
                Qtde Total:
                <br/>
                <span><span v-html="pesquisa.servico.totais._qtde"></span></span>
              </div>
              <div class="venda">
                Valor Total:
                <br/>
                <span>R$ <span v-html="pesquisa.servico.totais._total"></span></span>
              </div>
              <div class="venda" :class="pesquisa.servico.totais.ticket_medio > 0 ? 'lucro' : (pesquisa.servico.totais.ticket_medio < 0 ? 'custo' : '')">
                Ticket Médio:
                <br/>
                <span>R$ <span v-html="pesquisa.servico.totais._ticket_medio"></span></span>
              </div>
            </div>
          </div>

          <!-- SETA OS DADOS DOS SERVIÇOS -->
          <App-Demanda-Relatorio-Por-Itens-Tabela
          :cpntDemanda="cpntDemanda + '_servico'"
          :cpntApiTabPer="mper.tabper"
          :cpntApiTabPerOrder="mper.orderOptions"
          :cpntLinhas="pesquisa.servico.linhas"
          :cpntColunas="mper.fieldOptions"
          :cpntTotais="pesquisa.servico.totais"
          :cpntTotal="pesquisa.servico.countAll"
          :cpntMontarRouter="demRelPorItensMontarRouter"
          :cpntMontarMethod="demRelPorItensMontarMethod"
          :cpntTratarLinhas="demRelMaisUtiTaTratarLinhas"
          :cpntBotaoExportar="exportar"
          :cpntApiMontarQueryGet="(pag, rpp) => { return demRelPorItensMontarQueryGet(pag, rpp, 'servico') }"
          :cpntFiltros="filtros"
          :cpntRpp="Number(tabper.rpp)"

          @UPDATE_TOTAIS="(value) => { demRelPorItensSetarTotais(value) }"
          ></App-Demanda-Relatorio-Por-Itens-Tabela>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dem-rel-mais-uti-botao {
  margin-top: 10px;
  text-align: center;
}
.dem-rel-mais-uti-res {
  margin-top: 10px;
}
.dem-rel-mais-uti-res > .grafico {
  margin-bottom: 15px;
}
  .dem-rel-mais-uti-res > .grafico > div {
    width: 200px;
    margin-left: 15px;
    margin-bottom: 15px;
    display: block;
  }
    .dem-rel-mais-uti-res > .nenhum-reg {
      text-align: center;
    }

    .dem-rel-mais-uti-res > .totais {
    max-width: 600px;
    margin: 0px auto;
    border: 1px solid #d5dee5;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 0px;
    margin-top: 15px;
    padding: 10px 0px;
    text-align: center;
    background-color: #f4f9fe;
    text-decoration: none;
    color: #333;
  }
  .dem-rel-mais-uti-res > .totais > .titulo {
    padding-bottom: 5px;
  }
    .dem-rel-mais-uti-res > .totais > .titulo svg {
      vertical-align: -3px;
    }

    .dem-rel-mais-uti-res > .totais > div > .cpnt-app-explica {
      margin-right: 5px;
      margin-top: -5px;
    }
  .dem-rel-mais-uti-res > .totais > .valores > div {
    clear: both;
    display: inline-block;
    margin: 0px 10px;
    width: calc((100% / 3) - 20px);
  }
  .dem-rel-mais-uti-res > .totais > .valores > div > span {
    font-weight: bold;
  }

  .dem-rel-mais-uti-res > .totais > .valores > div.custo > span {
    color: red;
  }
  .dem-rel-mais-uti-res > .totais > .valores > div.venda > span {
    color: green;
  }
  .dem-rel-mais-uti-res > .totais > .valores > div.lucro > span {
    color: blue;
  }
</style>

<style>
.dem-rel-mais-uti-res > .dem-rel-mais-uti-tab > div > table {
  width: 100%;
  margin-bottom: 20px;
}
.dem-rel-mais-uti > .dem-rel-mais-uti-botao > .cpnt-mper > button {
  margin: 0px 8px !important;
  height: 30px !important;
  width: 30px !important;
  padding: 0px !important;
  text-align: center !important;
}
.dem-rel-mais-uti-res > .dem-rel-mais-uti-tp_grafico > div > div > div {
  width: 100% !important;
}

.dem-rel-mais-uti > .app-fil-rel > div > div > table {
  max-width: 500px;
  margin: 0px auto;
}
</style>

<script>
  var moment = require('moment')

  export default {
    props: {
      cpntFiltros: {
        required: false,
        type: Object
      },
      cpntDemanda: {
        required: true
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'App-Minha-Personalizacao': () => import('@/components/_geral/Minha-Personalizacao.vue'),
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Demanda-Relatorio-Por-Itens-Tabela': () => import('@/components/demanda/Relatorio/Demanda-Relatorio-Por-Itens-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        pesquisa: null,
        grafico: null,
        mostrarGrafico: '',
        tabper: {},
        mper: {
          tabper: '',
          rpp: true,
          order: true,
          orderOptions: [],
          field: true,
          fieldOptions: [],
          filtro: false,
        },
        tamanho: '98%',
        permissoes: {
          vei: false,
          pet: false,
          pro: false,
          ser: false
        },
        filtros: {
          dem_sta: [ '2' ],
          con: '',
          pet: '',
          vei: '',
          pro: '',
          pro_cat: '',
          pro_mar: '',
          ser: '',
          ser_cat: '',
          dat: '40'
        },
        params: {
          pag: 1,
          rpp: 10,
          tot: 0,
          limitG: 3000,
          qtdeMes: null,
          dataIni: '',
          dataFim: '',

          tipo: 'ticket_medio',
          colunas: [],
          valores: {}
        },
        vetor: {
          produto: {},
          servico: {}
        },
        exportar: {
          format: [ 'xlsx', 'pdf' ],
          search: true,
          // field: [
          //   { item_codigo:                                      'Código'                },
          //   { item_nome:                                        'Nome'                  },

          //   { demandaId_count_count:                            'Qtde Demanda'          },
          //   { qtde_sum:                                         'Qtde Total'            },
            
          //   { valor_tot_sum:                                    'Subtotal'              },
          //   // { valor_tot_sum:                                    { a: 'Subtotal',                   format: "bdtoreal" } }, // NÃO FUNCIONA PARA ESSE CAMPO

          //   { valor_fre_sum:                                    { a: 'Valor Frete',                format: "bdtoreal" } },
          //   { valor_seg_sum:                                    { a: 'Valor Seguro',               format: "bdtoreal" } },
          //   { valor_des_sum:                                    { a: 'Valor Desconto',             format: "bdtoreal" } },
          //   { valor_oda_sum:                                    { a: 'Valor ODA',                  format: "bdtoreal" } },
          //   { p_icms_bc_v_sum:                                  { a: 'Valor BC ICMS',              format: "bdtoreal" } },
          //   { p_icms_v_sum:                                     { a: 'Valor ICMS',                 format: "bdtoreal" } },
          //   { p_icms_st_bc_v_sum:                               { a: 'Valor BC ST ICMS',           format: "bdtoreal" } },
          //   { p_icms_st_v_sum:                                  { a: 'Valor ICMS ST',              format: "bdtoreal" } },
          //   { p_icms_fcp_st_v_sum:                              { a: 'Valor ICMS FCP ST',          format: "bdtoreal" } },
          //   { p_pis_bc_v_sum:                                   { a: 'Valor BC PIS',               format: "bdtoreal" } },
          //   { p_pis_v_sum:                                      { a: 'Valor PIS',                  format: "bdtoreal" } },
          //   { p_cofins_bc_v_sum:                                { a: 'Valor BC COFINS',            format: "bdtoreal" } },
          //   { p_cofins_v_sum:                                   { a: 'Valor COFINS',               format: "bdtoreal" } },
          //   { p_ipi_bc_v_sum:                                   { a: 'Valor BC IPI',               format: "bdtoreal" } },
          //   { p_ipi_v_sum:                                      { a: 'Valor IPI',                  format: "bdtoreal" } }
          // ]
        },
        campos: {
          tp_grafico: {
            status: '',
            nome: 'Apresentar Gráfico por:',
            options: [
              { id: 'ticket_medio', nome: 'Ticket médio' },
              { id: 'venda_total',  nome: 'Venda Total' },
              { id: 'qtde_total',   nome: 'Quantidade Total' }
            ],
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            value: 'ticket_medio',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.campos.tp_grafico.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // VERIFICA SE HOUVE MUDANÇA NO VALOR
              if (this.params.tipo !== (typeof value === 'string' ? value : value.id)) {
                // ATUALIZA O TIPO
                this.params.tipo = (typeof value === 'string' ? value : value.id)

                // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS
                this.demRelPorItensTratarDadosGrafico()
              }
            }
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.demRelPorItensSetarStatusGeral('carregando')

      // FAZ A VERIFICAÇÃO DAS PERMISSÕES DO USUARIO
      this.demRelPorItensVerificarPermissao()

      // CHAMA A FUNÇÃO PARA INICIAR O CARREGAMENTO
      this.demRelPorItensIniciar()
    },
    methods: {
      demRelPorItensBuscarValorMper: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.mper.tabper) !== -1 || [ '', null, undefined ].indexOf(this.$store.state.mPer[this.mper.tabper]) === -1) {
            success()
          } else {
            this.$store.state.comunicaAPI('/config/mper/get/', 'GET', this.mper.tabper, (retorno) => {
              // INICIA O VETOR DE PERSONALIZAÇÃO
              var vetor = { field: '', rpp: '10', order: '0', flag: false, filtro: '' }
    
              // VERIFICA SE EXISTE O FILTRO
              retorno.data.filtro = ''
              if ([ '', null, undefined ].indexOf(retorno.data.id_cg_filtro_j_filtro) === -1) {
                // CONVERTE O VALOR RECEBIDO
                retorno.data.id_cg_filtro_j_filtro.j_filtro = JSON.parse(retorno.data.id_cg_filtro_j_filtro.j_filtro)
    
                // PEGA O VALOR CONVERTIDO
                retorno.data.filtro = JSON.parse(JSON.stringify(retorno.data.id_cg_filtro_j_filtro))
    
                // DELETA O VALOR NÃO UTILIZADO MAIS
                delete retorno.data.id_cg_filtro_j_filtro
              }
    
              // VERIFICA SE TEM MINHA PERSONALIZAÇÃO
              var flag = Object.values(retorno.data).filter(item => [ '', null, undefined ].indexOf(item) === -1).length >= 1
    
              // VERIFICA SE FOI ENCONTRADO ALGUMA PERSONALIZAÇÃO
              if (flag === true) {
                vetor = retorno.data
                vetor.flag = true
              }
    
              // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
              this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: this.mper.tabper, dados: vetor })
        
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              success()
            }, this.demRelPorItensSetarStatusGeral)
          }
        })
      },
      demRelPorItensSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelPorItensVerificarPermissao: function () {
        // VERIFICA SE TEM PERMISSÃO VEICULO
        this.permissoes.vei = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PET
        this.permissoes.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO PRODUTO
        this.permissoes.pro = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, null, null, false) === true

        // VERIFICA SE TEM PERMISSÃO SERVIÇO
        this.permissoes.ser = this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true
      },
      demRelPorItensMontarWhereFiltro: function (campo) {
        // INICIA A VARIAVEL WHERE
        var where = {} 
        
        // SETA O VALOR DE CADA CAMPO
        switch (campo) {
          case 'pro':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.pro_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.pro_cat.join() })
            }

            // VERIFICA SE TEM QUE FILTRAR MARCA
            if (this.filtros.pro_mar !== '') {
              where.aAnd.push({ f: 'id_mar', o: '=', v: this.filtros.pro_mar.join() })
            }
            break

          case 'ser':
            // SETA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] }

            // VERIFICA SE TEM QUE FILTRAR CATEGORIA
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ f: 'id_cat', o: '=', v: this.filtros.ser_cat.join() })
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return where
      },
      demRelPorItensAtualizarFiltro: function (value, chave) {
        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
        switch (chave) {
          case 'dem':
            if ([ '', null, undefined ].indexOf(this.$refs.dem) === -1) {
              // LIMPA OS OPTIONS DO CAMPO
              this.$refs.dem.options = null
    
              // LIMPA OS OPTIONS DO CAMPO
              this.$refs.time = new Date().getTime()
            }
            break

          case 'pro_cat':
          case 'pro_mar':
            this.filtros.pro = ''
            break

          case 'ser_cat':
            this.filtros.ser = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelPorItensBuscarDemandaStatus: function (callback) {
        // INICIA A VARIAVEL OPTIONS
        var options = []

        // VERIFICA A DEMANDA
        if (this.cpntDemanda === 'venda') {
          options = options.concat([
            { id: '1', nome: 'Orçamento de Venda' },
            { id: '2', nome: 'Venda' }
          ])
        } else if (this.cpntDemanda === 'compra') {
          options = options.concat([
            { id: '1', nome: 'Orçamento de Compra' },
            { id: '2', nome: 'Compra' }
          ])
        }

        // RETORNA O VALOR MONTADO
        callback(options)
      },
      demRelPorItensIniciar: function () {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // LIMPA O GRAFICO SE ESTIVER PREENCHIDO
        this.grafico = null

        // CARREGA O NOME DA COLUNA NA TABELA
        var nomeColTotal = (this.cpntDemanda === 'venda' ? 'Venda' : 'Compra') + ' Total'

        // LIMPA AS VARIAVEIS
        this.mper.tabper = ''
        this.mper.rpp = true
        this.mper.order = true
        this.mper.orderOptions = [
          { id: '0', nome: 'Maior Quantidade Vendido Decrescente' },
          { id: '1', nome: 'Maior Quantidade Vendido Crescente'   },
          { id: '2', nome: 'Maior Valor Vendido Decrescente'      },
          { id: '3', nome: 'Maior Valor Vendido Crescente'        },
          { id: '4', nome: 'Ordem Alfabética Item Crescente'      },
          { id: '5', nome: 'Ordem Alfabética Item Decrescente'    },
          { id: '6', nome: 'Código Item Crescente'                },
          { id: '7', nome: 'Código Item Decrescente'              },
          { id: '8', nome: 'Código Fornecedor Item Crescente'     },
          { id: '9', nome: 'Código Fornecedor Item Decrescente'   }
        ]
        this.mper.field = true
        this.mper.fieldOptions = [
          // { mPer: 1,  chave: 'item_tipo',        nome: 'Tipo',                  export: { fields: {} } },
          { mPer: 1,  chave: 'posicao',               nome: 'Posição',             export: { fields: { virtual_posicao: 'Posição' } } },
          { mPer: 1,  chave: 'item_codigo',           nome: 'Cód.',                export: { fields: { item_codigo: 'Código' } } },
          { mPer: 1,  chave: 'item_cod_fornecedor',   nome: 'Cód. Fornecedor',     export: { fields: { item_cod_fornecedor: 'Código Fornecedor' } } },
          { mPer: 2,  chave: 'item_nome',             nome: 'Nome',                export: { fields: { item_nome: 'Nome' } } },

          { mPer: 0, chave: 'demandaId_count_count',  nome: 'Quantidade ' + (this.cpntDemanda === 'venda' ? 'Venda' : 'Compra'), explica: { mensagem: 'Número de ' + this.cpntDemanda + '(s) que foram incluído este(s) item(ns).', posicaoMy: 'top right', posicaoAt: 'bottom left' } },
          { mPer: 1, chave: '_qtde_sum',              nome: 'Quantidade Total',    export: { fields: { qtde_sum:             { a: 'Quantidade Total' } } } },
          { mPer: 0, chave: '_valor_tot_sum',         nome: 'Subtotal',            export: { fields: { valor_tot_sum:        { a: 'Subtotal' } } } },
  
          { mPer: 0, chave: '_valor_fre_sum',         nome: 'Valor Frete',         export: { fields: { valor_fre_sum:        { format: 'bdtoreal', a: 'Valor Frete' } } } },
          { mPer: 0, chave: '_valor_seg_sum',         nome: 'Valor Seguro',        export: { fields: { valor_seg_sum:        { format: 'bdtoreal', a: 'Valor Seguro' } } } },
          { mPer: 0, chave: '_valor_des_sum',         nome: 'Valor Desconto',      export: { fields: { valor_des_sum:        { a: 'Valor Desconto' } } } },
          { mPer: 0, chave: '_valor_oda_sum',         nome: 'Valor ODA',           export: { fields: { valor_oda_sum:        { format: 'bdtoreal', a: 'Valor ODA' } } } },
          { mPer: 0, chave: '_p_icms_bc_v_sum',       nome: 'Valor BC ICMS',       export: { fields: { p_icms_bc_v_sum:      { format: 'bdtoreal', a: 'Valor BC ICMS' } } } },
          { mPer: 0, chave: '_p_icms_v_sum',          nome: 'Valor ICMS',          export: { fields: { p_icms_v_sum:         { format: 'bdtoreal', a: 'Valor ICMS' } } } },
          { mPer: 0, chave: '_p_icms_st_bc_v_sum',    nome: 'Valor BC ST ICMS',    export: { fields: { p_icms_st_bc_v_sum:   { format: 'bdtoreal', a: 'Valor BC ST ICMS' } } } },
          { mPer: 0, chave: '_p_icms_st_v_sum',       nome: 'Valor ICMS ST',       export: { fields: { p_icms_st_v_sum:      { format: 'bdtoreal', a: 'Valor ICMS ST' } } } },
          { mPer: 0, chave: '_p_icms_fcp_st_v_sum',   nome: 'Valor ICMS FCP ST',   export: { fields: { p_icms_fcp_st_v_sum:  { format: 'bdtoreal', a: 'Valor ICMS FCP ST' } } } },
          { mPer: 0, chave: '_p_pis_bc_v_sum',        nome: 'Valor BC PIS',        export: { fields: { p_pis_bc_v_sum:       { format: 'bdtoreal', a: 'Valor BC PIS' } } } },
          { mPer: 0, chave: '_p_pis_v_sum',           nome: 'Valor PIS',           export: { fields: { p_pis_v_sum:          { format: 'bdtoreal', a: 'Valor PIS' } } } },
          { mPer: 0, chave: '_p_cofins_bc_v_sum',     nome: 'Valor BC COFINS',     export: { fields: { p_cofins_bc_v_sum:    { format: 'bdtoreal', a: 'Valor BC COFINS' } } } },
          { mPer: 0, chave: '_p_cofins_v_sum',        nome: 'Valor COFINS',        export: { fields: { p_cofins_v_sum:       { format: 'bdtoreal', a: 'Valor COFINS' } } } },
          { mPer: 0, chave: '_p_ipi_bc_v_sum',        nome: 'Valor BC IPI',        export: { fields: { p_ipi_bc_v_sum:       { format: 'bdtoreal', a: 'Valor BC IPI' } } } },
          { mPer: 0, chave: '_p_ipi_v_sum',           nome: 'Valor IPI',           export: { fields: { p_ipi_v_sum:          { format: 'bdtoreal', a: 'Valor IPI' } } } },
 
          { mPer: 1, chave: '_total',                 nome: nomeColTotal,          export: { fields: { virtual_item_venda_total_agrupado: { a: nomeColTotal } } } },
          { mPer: 1, chave: '_valor_medio',           nome: 'Ticket Médio',        export: { fields: { virtual_item_ticket_medio_agrupado: { a: 'Ticket Médio' } } } },
          { mPer: 1, chave: 'historico',              nome: 'Histórico',           export: { fields: {} } }
        ]

        // VERIFICA QUAL É A PERSONALIZAÇÃO QUE DEVE REALIZAR
        switch (this.cpntDemanda) {
          case 'venda':
            this.mper.tabper = 'VendaMaisVendidos'
            break

          case 'compra':
            this.mper.tabper = 'CompraMaisComprados'
            break
        }

        // SETA OS VALORES RECEBIDOS
        if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1) {
          for (var index in this.cpntFiltros) {
            if ([ undefined ].indexOf(this.filtros[index]) === -1) {
              this.demRelPorItensAtualizarFiltro(this.cpntFiltros[index], index)
            }
          }
        }

        // LIMPA OS VALORES DA TELA 
        this.pesquisa = null

        // CARREGA A MINHA PERSONALIZAÇÃO
        this.demRelPorItensBuscarValorMper().then(() => {
          // SETA O STATUS DA PAGINA
          this.demRelPorItensSetarStatusGeral('')


          // VERIFICA SE DEVE REALIZAR O PESQUISAR OU NÃO
          if ([ 'vendas_relatorio_mais_usados_busca', 'compras_relatorio_mais_usados_busca' ].indexOf(this.$route.name) !== -1) {
            this.demRelPorItensPesquisar()
          }
  
          // // REALIZAR A PESQUISA
          // this.demRelPorItensPesquisar()
        })
      },
      demRelPorItensMontarOrder: function (chave) {

        // INICIA A VARIAVEL
        var order = {}

        // FAZ AS VERIFICAÇÕES
        switch (this.tabper.order) {
          case '0':
            order = { qtde_sum: 'desc', item_nome: 'asc' }
            break

          case '1':
            order = { qtde_sum: 'asc', item_nome: 'asc' }
            break

          case '2':
            order = { valor_tot_sum: 'desc', item_nome: 'asc' }
            break

          case '3':
            order = { valor_tot_sum: 'asc', item_nome: 'asc' }
            break

          case '4':
            order = { item_nome: 'asc', item_codigo: 'desc' }
            break

          case '5':
            order = { item_nome: 'desc', item_codigo: 'desc' }
            break

          case '6':
            order = { item_codigo: 'asc' }
            break

          case '7':
            order = { item_codigo: 'desc' }
            break

          case '8':
            if(chave !== 'venda_servico' && chave !== 'venda_servico_grafico')
              order = { item_cod_fornecedor: 'asc' }
            break

          case '9':
            if(chave !== 'venda_servico' && chave !== 'venda_servico_grafico')
              order = { item_cod_fornecedor: 'desc' }
            break
        }

        // RETORNA A ROTA MONTADA
        return order
      },
      demRelPorItensMontarRouter: function (demanda) {
        // INICIA A VARIAVEL
        var rota = {}

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
            rota = '/venda/produto/get'
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
            rota = '/venda/servico/get'
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
            rota = '/demanda/dem-compra/dem-produto/get'
            break
        }

        // RETORNA A ROTA MONTADA
        return rota
      },
      demRelPorItensMontarMethod: function (demanda) {
        // INICIA A VARIAVEL
        var metodo = {}

        // FAZ AS VERIFICAÇÕES
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
          case 'venda_servico':
          case 'venda_servico_grafico':
          case 'compra_produto':
          case 'compra_produto_grafico':
            metodo = 'POST'
            break
        }

        // RETORNA O VALOR MONTADO
        return metodo
      },
      demRelPorItensMontarFieldVirtual: function (demanda) {
        // INICIA O VETOR
        var field = []

        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
            field = [ 'posicao', 'item_venda_total_agrupado', 'item_ticket_medio_agrupado' ]
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
            field = [ 'posicao', 'item_compra_total_agrupado', 'item_ticket_medio_agrupado' ]
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
            field = [ 'posicao', 'item_ticket_medio_agrupado' ]
            break
        }

        // RETORNA O VALOR MONTADO
        return field
      },
      demRelPorItensMontarField: function (demanda) {
        // INICIA A VARIAVEL
        var field = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
            field = {
              id: null,
              cod_venda: { a: 'demandaId_count', o: 'count', j: { vencimento: { a: '__REMOVER__' } } },
              id_pro: { j: { id: { a: 'item' }, codigo: { a: 'item_codigo' }, cod_fornecedor: { a: 'item_cod_fornecedor' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: { o: 'sum'  },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_icms_bc_v: { o: 'sum' },
              p_icms_v: { o: 'sum' },
              p_icms_st_bc_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              p_pis_bc_v: { o: 'sum' },
              p_pis_v: { o: 'sum' },
              p_cofins_bc_v: { o: 'sum' },
              p_cofins_v: { o: 'sum' },
              p_ipi_bc_v: { o: 'sum' },
              p_ipi_v: { o: 'sum' }
            }
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
            field = {
              id: null,
              cod_venda: { a: 'demandaId_count', o: 'count', j: { vencimento: { a: '__REMOVER__' } } },
              id_ser: { j: { id: { a: 'item_codigo' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: { o: 'sum'  },
              valor_tot: { o: 'sum'  }
            }
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
            field = {
              id: null,
              dem_compra: { a: 'demandaId_count', o: 'count', j: { vencimento: { a: '__REMOVER__' } } },
              id_pro: { j: { id: { a: 'item' }, codigo: { a: 'item_codigo' }, cod_fornecedor: { a: 'item_cod_fornecedor' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } },
              qtde: { o: 'sum'  },
              valor_tot_novo: { a: 'valor_tot', o: 'sum' },
              valor_fre: { o: 'sum' },
              valor_seg: { o: 'sum' },
              valor_des_novo: { a: 'valor_des', o: 'sum' },
              valor_oda: { o: 'sum' },
              p_icms_bc_v: { o: 'sum' },
              p_icms_v: { o: 'sum' },
              p_icms_st_bc_v: { o: 'sum' },
              p_icms_st_v: { o: 'sum' },
              p_icms_fcp_st_v: { o: 'sum' },
              p_pis_bc_v: { o: 'sum' },
              p_pis_v: { o: 'sum' },
              p_cofins_bc_v: { o: 'sum' },
              p_cofins_v: { o: 'sum' },
              p_ipi_bc_v: { o: 'sum' },
              p_ipi_v: { o: 'sum' }
            }
            break
        }

        // RETORNA OS FIELDS MONTADOS
        return field
      },
      demRelPorItensMontarWhere: function (demanda) {
        // INICIA O WHERE QUE SERÁ REALIZADO
        var where = {}

        // VERIFICA A DEMANDA QUE ESTÁ SENDO TRATADA
        switch (demanda) {
          case 'venda_produto':
          case 'venda_produto_grafico':
            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: 'venda', f: 'status', o: '<>', v: '3' } ,
            ] }
            
            // VERIFICA POSSIVEL PERSONALIZAÇÃO
            if ([ '2298', '8007', '1933' ].indexOf(this.$store.state.token.clu) !== -1) {
              where.aAnd.push({
                aOr: [
                  { m: 'venda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '0' }
                ]
              })
            } else {
              where.aAnd.push({
                aOr: [
                  { m: 'venda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' }
                ]
              })
            }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '0' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'isNull' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
            // INICIA O WHERE
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'venda', f: 'status', o: '<>', v: '3' } ] }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO VEICULO SOLICITADO
            if (this.filtros.vei === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '' })
            } else if (this.filtros.vei !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: this.filtros.vei.join() })
            }

            // SETA A BUSCA DO PET SOLICITADO
            if (this.filtros.pet === '__NENHUM__') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: '=', v: '' })
            } else if (this.filtros.pet !== '') {
              where.aAnd.push({ m: 'venda', f: 'id_pet', o: 'in', v: this.filtros.pet.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.ser !== '') {
              where.aAnd.push({ f: 'id_ser', o: 'in', v: this.filtros.ser.join() })
            }
    
            // SETA A BUSCA DO CATEGORIA DE SERVIÇO ESPECIFICADO
            if (this.filtros.ser_cat !== '') {
              where.aAnd.push({ m: 'servico', f: 'id_cat', o: 'in', v: this.filtros.ser_cat.join() })
            }

            
            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'venda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'venda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break

          case 'compra_produto':
          case 'compra_produto_grafico':
            // INICIA O WHERE
            where = { aAnd: [
              { f: 'status', o: '=', v: '1' },
              { m: 'demanda', f: 'dem_status', o: '<>', v: '3' },
              {
                aOr: [
                  { m: 'demanda', f: 'p_doc_ope', o: 'isNull' },
                  { m: 'demanda', f: 'p_doc_ope', o: '=', v: '0' }
                ]
              }
            ] }

            // VERIFICA O STATUS QUE DEVE BUSCAR
            if (this.filtros.dem_sta !== '') {
              where.aAnd.push({ m: 'demanda', f: 'dem_status', o: 'in', v:  this.filtros.dem_sta.join() })
            }

            // SETA A BUSCA DO CONTATO SOLICITADO
            if (this.filtros.con !== '') {
              where.aAnd.push({ m: 'demanda', f: 'id_con', o: 'in', v: this.filtros.con.join() })
            }

            // SETA A BUSCA DO SERVIÇO ESPECIFICADO
            if (this.filtros.dat !== '') {
              where.aAnd.push({ aAnd: [
                { m: 'demanda', f: 'vencimento', o: '>=', v: this.filtros.dat._dataIni + ' 00:00:00' },
                { m: 'demanda', f: 'vencimento', o: '<=', v: this.filtros.dat._dataFim + ' 23:59:59' }
              ] })
            }
            break
        }

        // VERIFICA SE DEVE INCLUIR FILTRO DE PESQUISA DE PRODUTO
        if ([ 'venda_servico', 'venda_servico_grafico' ].indexOf(demanda) === -1 && this.filtros.pro !== '__NENHUM__') {
          // SETA A BUSCA DO PRODUTO ESPECIFICADO
          if (this.filtros.pro !== '') {
            where.aAnd.push({ f: 'id_pro', o: 'in', v: this.filtros.pro.join() })
          }
  
          // SETA A BUSCA DO CATEGORIA DE PRODUTO ESPECIFICADO
          if (this.filtros.pro_cat !== '') {
            where.aAnd.push({ m: 'produto', f: 'id_cat', o: 'in', v: this.filtros.pro_cat.join() })
          }
  
          // SETA A BUSCA DO MARCA DE PRODUTO ESPECIFICADO
          if (this.filtros.pro_mar !== '') {
            where.aAnd.push({ m: 'produto', f: 'id_mar', o: 'in', v: this.filtros.pro_mar.join() })
          }
        }

        // RETORNA O WHERE MONTADO
        return where
      },
      demRelPorItensSetarTotais: function (retorno) {
        // INICIA A VARIAVEL
        var pesquisa = typeof this.pesquisa === 'object' ? this.pesquisa : {}

        // OCULTA O GRAFICO
        this.grafico = null

        // PEGA AS CHAVES DO RETORNO
        var keys = Object.keys(retorno)

        // SETA O VALOR INICIAL
        pesquisa = {}

        // VERIFICA SE TEM A PESQUISA DESEJADA
        if (keys.indexOf('compra_produto') !== -1) {
          pesquisa.produto = {  linhas: [], totais: {}, countAll: '0' }
          pesquisa.produto.linhas = retorno.compra_produto.data
          pesquisa.produto.countAll = retorno.compra_produto.countAll
        } else {
          // VERIFICA SE TEM RETORNO DE PRODUTO
          if (keys.indexOf('venda_produto') !== -1) {
            pesquisa.produto = {  linhas: [], totais: {}, countAll: '0' }
            pesquisa.produto.countAll = retorno.venda_produto.countAll
            pesquisa.produto.linhas = retorno.venda_produto.data
          }

          // VERIFICA SE TEM RETORNO DE SERVIÇO
          if (keys.indexOf('venda_servico') !== -1) {
            pesquisa.servico = { linhas: [], totais: {}, countAll: '0' }
            pesquisa.servico.countAll = retorno.venda_servico.countAll
            pesquisa.servico.linhas = retorno.venda_servico.data
          }
        }

        // SETA O VALOR RECEBIDO
        this.pesquisa = typeof this.pesquisa === 'object' ? Object.assign(this.pesquisa, pesquisa) : pesquisa

        // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO
        if (Object.keys(pesquisa).length >= 1) {
          this.demRelPorItensMontarGraficoDados(0)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demRelMaisUtiTaTratarLinhas: function (vetor, demanda) {
        // IMPORTA A FUNÇAO
        const CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM = require('@/assets/js/Funcoes-Gerais.js').CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM

        // INICIA A VARIAVEL
        var tipo = demanda.indexOf('produto') !== -1 ? 'produto' : 'servico'
        
        // INICIA A VARIAVEIS A SEREM UTILIZADO
        // var posicao = 0
        // var fator = 0
        // var total = Number(this.pesquisa[tipo].countAll)
        
        // // VERIFICA O MODO DE CALCULAR A POSIÇÃO
        // switch (this.tabper.order) {
        //   case '0':
        //   case '2':
        //   case '4':
        //   case '6':
        //     // CALCULA A POSIÇÃO
        //     posicao = ((this.params.pag * this.params.rpp) - this.params.rpp) + 1
    
        //     // VERIFICA SE O NUMERO É NEGATIVO
        //     if (posicao < 0) {
        //       posicao = 1
        //     }

        //     // SETA O FATOR
        //     fator = 1
        //     break
          
        //   case '1':
        //   case '3':
        //   case '5':
        //   case '7':
        //     // CALCULA A POSIÇÃO
        //     posicao = total - ((this.params.pag * this.params.rpp) - this.params.rpp)
    
        //     // VERIFICA SE O NUMERO É NEGATIVO
        //     if (posicao < 0) {
        //       posicao = 1
        //     }

        //     // SETA O FATOR
        //     fator = -1
        //     break
        // }

        // RODA O VETOR SEPARANDO OS VALORES
        for (var index in vetor) {
          // VERIFICA O TIPO DE REGISTRO
          if (vetor[index].id_pro !== undefined) {
            // SETA O TIPO DE REGISTRO
            vetor[index].item_tipo = 'Produto'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'produto'
          } else {
            // SETA O TIPO DE REGISTRO
            vetor[index].item_tipo = 'Serviço'
            
            // SETA O TIPO DE REGISTRO
            tipo = 'servico'
          }

          // SETA OS DADOS RECEBIDOS
          if (vetor[index].virtual_posicao !== undefined) {
            vetor[index].posicao = vetor[index].virtual_posicao
          }
          if (tipo === 'servico') {
            vetor[index].total = (Number(vetor[index].valor_tot_sum) / 100).toFixed(2)
          }

          // SETA A POSIÇÃO DO PRODUTO NO VETOR
          vetor[index].posicao = (vetor[index].posicao.toString() + 'º')

          // MANDA CALCULAR OS VALORES
          vetor[index] = CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(vetor[index], tipo, {
            qtde:             'qtde_sum',
            valor_tot:        'valor_tot_sum',
            valor_fre:        'valor_fre_sum',
            valor_seg:        'valor_seg_sum',
            valor_des:        'valor_des_sum',
            valor_oda:        'valor_oda_sum',
            p_icms_bc_v:      'p_icms_bc_v_sum',
            p_icms_v:         'p_icms_v_sum',
            p_icms_st_bc_v:   'p_icms_st_bc_v_sum',
            p_icms_st_v:      'p_icms_st_v_sum',
            p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
            p_pis_bc_v:       'p_pis_bc_v_sum',
            p_pis_v:          'p_pis_v_sum',
            p_cofins_bc_v:    'p_cofins_bc_v_sum',
            p_cofins_v:       'p_cofins_v_sum',
            p_ipi_bc_v:       'p_ipi_bc_v_sum',
            p_ipi_v:          'p_ipi_v_sum',
            valor_medio:      null,
            total:            null
          })

          // // SOMA AS POSIÇÕES CONFORME VETOR
          // posicao = (posicao + fator)
        }

        // RETORNA OS VALORES TRATADOS
        return vetor
      },
      demRelPorItensMontarGraficoDados: function (time = 100) {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // FECHA O GRAFICO 
        this.grafico = null
        
        // AGUARDA O CARREGAMENTO
        setTimeout(() => {
          // INICIA AS VARIAVEIS
          var cor = null
          var colunas = []
          var valores = { 
            qtde:         { data: [], fill: false, backgroundColor: [], borderColor: [], borderWidth: 1 },
            valor_tot:    { data: [], fill: false, backgroundColor: [], borderColor: [], borderWidth: 1 },
            valor_medio:  { data: [], fill: false, backgroundColor: [], borderColor: [], borderWidth: 1 }
          }
  
          // PEGA A QUANTIDADE TOTAL DE LINHAS
          var qtdeP = 0
          var qtdeS = 0
          // var qtdeT = 0
          // var porP = 0
          // var porS = 0
          if ([ '', null, undefined ].indexOf(this.pesquisa.produto) === -1) {
            qtdeP = Number(this.pesquisa.produto.countAll)
          }
          if ([ '', null, undefined ].indexOf(this.pesquisa.servico) === -1) {
            qtdeS = Number(this.pesquisa.servico.countAll)
          }

          // FECHA O GRAFICO 
          this.grafico = ''

          // VERIFICA SE DEVE BLOQUEAR A QUANTIDADE
          // if ((qtdeP + qtdeS) <= this.params.limitG) {
            // // SOMA A QUANTIDADE DE TOTAL
            // qtdeT = (qtdeP + qtdeS)
    
            // // CALCULA A PROPORÇÃO A SER MOSTRADA
            // if (qtdeS === 0) {
            //   porP = 100
            //   porS = 0
            // } else if (qtdeP === 0) {
            //   porP = 0
            //   porS = 100
            // } else {
            //   // CALCULA UMA PROPORÇÃO DE PRODUTO E SERVIÇO
            //   porP = Number(Math.ceil((qtdeP / qtdeT) * 100).toFixed(0))
            //   porS = Number(Math.ceil((qtdeS / qtdeT) * 100).toFixed(0))
    
            //   // ARREDONDA A PORCENTAGEM DOS VALORES
            //   if (porP >= 100 && porS > 0) {
            //     porP = (porP - porS)
            //   }
            // }
            
            // INICIA QUERY
            var querys = {}
    
            // // VERIFICA A DEMANDA A SER BUSCADA
            // if (this.cpntDemanda === 'venda') {
            //   // PRODUTO
            //   if (qtdeP > 0 && this.filtros.pro !== '__NENHUM__' && this.permissoes.pro === true) {
            //     // MONTA O REQUEST
            //     querys.produto = this.demRelPorItensMontarPesquisa('venda_produto_grafico')
    
            //     // SETA A QUANTIDADE DE ITENS QUE DEVE BUSCAR
            //     querys.produto.parametro.limit.qty = (60 * (porP / 100)).toFixed(0)
            //   }
    
            //   // SERVIÇO
            //   if (qtdeS > 0 && this.filtros.ser !== '__NENHUM__' && this.permissoes.ser === true) {
            //     // MONTA O REQUEST
            //     querys.servico = this.demRelPorItensMontarPesquisa('venda_servico_grafico')
    
            //     // SETA A QUANTIDADE DE ITENS QUE DEVE BUSCAR
            //     querys.servico.parametro.limit.qty = (60 * (porS / 100)).toFixed(0)
            //   }
            // } else if (qtdeP > 0) {
            //   // MONTA O REQUEST
            //   querys.produto = this.demRelPorItensMontarPesquisa('compra_produto_grafico')
    
            //   // SETA A QUANTIDADE DE ITENS QUE DEVE BUSCAR
            //   querys.produto.parametro.limit.qty = (60 * (porP / 100)).toFixed(0)
            // }
    
            // INICIA A VARIAVEL 
            var qtdeSQL = 1
            var chave = ''
    
            // MONTA AS QUERYS PARA PRODUTO
            if (qtdeP > 0 && this.filtros.pro !== '__NENHUM__' && this.permissoes.pro === true) {
              // MONTA O REQUEST
              querys.produto_0 = this.demRelPorItensMontarPesquisa(this.cpntDemanda + '_produto_grafico')
    
              // SETA A QUANTIDADE DE REGISTRO QUE DEVE BUSCAR
              querys.produto_0.parametro.limit.qty = 1000
    
              // VERIFICA SE TEM MAIS DE 1000 REGISTRO PRA BUSCAR
              if (qtdeP > 1000) {
                for (var p = 1000; p <= qtdeP; p = (p + 1000)) {
                  if (p >= 0) {
                    // SETA O NOME DA CHAVE
                    chave = 'produto_' + qtdeSQL
    
                    // SETA A QUERY INICIAL
                    querys[chave] = JSON.parse(JSON.stringify(querys.produto_0))
    
                    // ALTERA O REGISTRO INICIAL
                    querys[chave].parametro.limit.row = p
    
                    // SOMA A QUANTIDADE DE SELECTS REALIZADOS
                    qtdeSQL++
                  }
                }
              }
            }
    
            // MONTA AS QUERYS PARA PRODUTO
            if (qtdeS > 0 && this.filtros.ser !== '__NENHUM__' && this.permissoes.ser === true && this.cpntDemanda === 'venda') {
              // MONTA O REQUEST
              querys.servico_0 = this.demRelPorItensMontarPesquisa(this.cpntDemanda + '_servico_grafico')
    
              // SETA A QUANTIDADE DE REGISTRO QUE DEVE BUSCAR
              querys.servico_0.parametro.limit.qty = 1000
    
              // VERIFICA SE TEM MAIS DE 1000 REGISTRO PRA BUSCAR
              if (qtdeS > 1000) {
                for (var s = 1000; s <= qtdeS; s = (s + 1000)) {
                  if (s >= 0) {
                    // SETA O NOME DA CHAVE
                    chave = 'servico_' + qtdeSQL
    
                    // SETA A QUERY INICIAL
                    querys[chave] = JSON.parse(JSON.stringify(querys.servico_0))
    
                    // ALTERA O REGISTRO INICIAL
                    querys[chave].parametro.limit.row = s
    
                    // SOMA A QUANTIDADE DE SELECTS REALIZADOS
                    qtdeSQL++
                  }
                }
              }
            }
    
            // VERIFICA SE TEM ALGUMA BUSCA A SER FEITA
            if (Object.keys(querys).length >= 1) {
              // FAZ A BUSCA DOS DADOS NA API
              this.$store.state.comunicaAPI('/rota-multipla', 'POST', querys, (retorno) => {
                // FLAG DO ERRO
                var erro = false
      
                // INICIA O VETOR
                var dados = []
      
                // JUNTA OS VALORES RECEBIDOS
                for (var index in retorno) {
                  if (retorno[index].code !== '200') {
                    // APRESENTA A MENSAGEM DE SUCESSO
                    this.$store.state.TRATAR_RET_LOT_API(retorno[index])
      
                    // SETA O STATUS NA TELA
                    this.demRelPorItensSetarStatusGeral(retorno[index])
      
                    // SETA O FLAG QUE FOI IDENTIFICADO UM ERRO
                    erro = true
      
                    // PARA DE RODAR O VETOR
                    break
                  } else {
                    dados = dados.concat(retorno[index].data)
                  }
                }
      
                // VERIFICAR SE TEM ALGUM ERRO NA BUSCA
                if (erro === false) {    
                  // IMPORTA A FUNÇAO
                  const FUN_RANDOM_COLOR = require('@/assets/js/Funcoes-Gerais.js').FUN_RANDOM_COLOR
                  const CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM = require('@/assets/js/Funcoes-Gerais.js').CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM
    
                  // INICIA A VARIAVEL
                  var chave = ''
                  var totaisP = {
                    qtde: 0,
                    valor_tot: 0,
                    valor_fre: 0,
                    valor_seg: 0,
                    valor_des: 0,
                    valor_oda: 0,
                    p_icms_st_v: 0,
                    p_icms_fcp_st_v: 0,
                    p_ipi_v: 0,
                    total: 0,
                    ticket_medio: 0
                  }
                  var totaisS = {
                    qtde: 0,
                    valor_tot: 0,
                    total: 0,
                    ticket_medio: 0
                  }
          
                  // RODA UM FOR MONTANDO OS DADOS PARA O GRAFICO
                  for (var indexV in dados) {
                    // PEGA O TIPO DE REGISTRO QUE ESTÁ SENDO USADO
                    var tipo = (dados[indexV].id_pro !== undefined ? 'produto' : 'servico')

                    // SETA OS DADOS RECEBIDOS
                    if (dados[indexV].virtual_posicao !== undefined) {
                      dados[indexV].posicao = dados[indexV].virtual_posicao
                    }
                    if (tipo === 'servico') {
                      dados[indexV].total = (Number(dados[indexV].valor_tot_sum) / 100).toFixed(2)
                    }
    
                    // MANDA CALCULAR OS VALORES
                    dados[indexV] = CALCULAR_E_MONTAR_VALOR_BRUTO_ITEM(dados[indexV], tipo, {
                      qtde:             'qtde_sum',
                      valor_tot:        'valor_tot_sum',
                      valor_fre:        'valor_fre_sum',
                      valor_seg:        'valor_seg_sum',
                      valor_des:        'valor_des_sum',
                      valor_oda:        'valor_oda_sum',
                      p_icms_st_v:      'p_icms_st_v_sum',
                      p_icms_fcp_st_v:  'p_icms_fcp_st_v_sum',
                      p_ipi_v:          'p_ipi_v_sum',
                      valor_medio:      null,
                      total:            null
                    })
    
                    // SOMA OS VALORES PARA TOTAIS
                    if (tipo === 'produto') {
                      // SOMA OS VALORES
                      totaisP.qtde              += Number(dados[indexV].qtde_sum)
                      totaisP.valor_tot         += Number(dados[indexV].valor_tot_sum)
                      totaisP.valor_fre         += Number(dados[indexV].valor_fre_sum)
                      totaisP.valor_seg         += Number(dados[indexV].valor_seg_sum)
                      totaisP.valor_des         += Number(dados[indexV].valor_des_sum)
                      totaisP.valor_oda         += Number(dados[indexV].valor_oda_sum)
                      totaisP.p_icms_st_v       += Number(dados[indexV].p_icms_st_v_sum)
                      totaisP.p_icms_fcp_st_v   += Number(dados[indexV].p_icms_fcp_st_v_sum)
                      totaisP.p_ipi_v           += Number(dados[indexV].p_ipi_v_sum)
                      totaisP.total             += Number(dados[indexV].total)
    
                      // INICIA A CHAVE DO VETOR
                      chave = '_' + dados[indexV].item
                    } else if (tipo === 'servico') {
                      totaisS.qtde              += Number(dados[indexV].qtde_sum)
                      totaisS.valor_tot         += Number(dados[indexV].valor_tot_sum)
                      totaisS.total             += Number(dados[indexV].total)
    
                      // INICIA A CHAVE DO VETOR
                      chave = '_' + dados[indexV].item_codigo
                    }
          
                    // VERIFICA SE O VETOR JÁ FOI CRIADO
                    if (colunas[chave] === undefined) {            
                      // ADICIONA O NOME DO CONTATO NA LINHA ABAIXO AO GRAFICO
                      colunas[chave] = dados[indexV].item_nome.toUpperCase()
          
                      // INICIA O VALOR DA CHAVE
                      valores.qtde.data[chave] = 0
                      valores.valor_tot.data[chave] = 0
                      valores.valor_medio.data[chave] = 0
          
                      // GERA AS NOVAS CORRES PARA OS CAMPOS
                      cor = FUN_RANDOM_COLOR()
          
                      // COLOCA AS CORES PARA CADA BARRA
                      valores.qtde.backgroundColor.push(cor[0])
                      valores.qtde.borderColor.push(cor[1])
                      valores.valor_tot.backgroundColor.push(cor[0])
                      valores.valor_tot.borderColor.push(cor[1])
                      valores.valor_medio.backgroundColor.push(cor[0])
                      valores.valor_medio.borderColor.push(cor[1])
                    }
          
                    // SETA O VALOR DA QUANTIDADE
                    valores.qtde.data[chave] += Number(dados[indexV].qtde_sum)
          
                    // SETA O VALOR TOTAL
                    valores.valor_tot.data[chave] += Number(dados[indexV].total)
          
                    // SETA O VALOR DO TICKET MEDIO
                    valores.valor_medio.data[chave] = (Number(dados[indexV].qtde_sum) === 0 ? 0 : Number((Number(dados[indexV].total) / Number(dados[indexV].qtde_sum)).toFixed(2)))
                  }
          
                  // PEGA APENAS OS VALORES
                  valores.qtde.data = Object.values(valores.qtde.data)
                  valores.valor_tot.data = Object.values(valores.valor_tot.data)
                  valores.valor_medio.data = Object.values(valores.valor_medio.data)
          
                  // MOSTRA O GRAFICO
                  this.grafico = ''
          
                  // SETA OS VALORES NOS PARAMETROS
                  this.params.colunas = colunas
                  this.params.valores = valores
          
                  // CHAMA A FUNÇÃO PRA MONTAR O GRAFICO NA TELA
                  this.demRelPorItensTratarDadosGrafico(colunas, valores)
    
                  // VERIFICA SE TEM VALOR A SER SETADO
                  if ([ '', null, undefined ].indexOf(this.pesquisa) === -1) {
                    // CALCULA O TICKET MEDIO
                    totaisP.ticket_medio = Number(totaisP.qtde) === 0 ? '0' : (totaisP.total / Number(totaisP.qtde)).toFixed(2)
                    totaisS.ticket_medio = Number(totaisS.qtde) === 0 ? '0' : (totaisS.total / Number(totaisS.qtde)).toFixed(2)
          
                    // FORMATA OS VALORES RECEBIDOS
                    for (var indexP in totaisP) {
                      // ARREDONDA O VALOR
                      totaisP[indexP] = Number(totaisP[indexP]).toFixed(2)
          
                      // FORMATA O VALOR
                      totaisP['_' + indexP] = ([ '', null, undefined, '---' ].indexOf(totaisP[indexP]) === -1) ? this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', totaisP[indexP]) : '0,00'
                    }
                    for (var indexS in totaisS) {
                      // ARREDONDA O VALOR
                      totaisS[indexS] = Number(totaisS[indexS]).toFixed(2)
          
                      // FORMATA O VALOR
                      totaisS['_' + indexS] = ([ '', null, undefined, '---' ].indexOf(totaisS[indexS]) === -1) ? this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', totaisS[indexS]) : '0,00'
                    }
          
                    // VERIFICA PRODUTO
                    if ([ '', null, undefined ].indexOf(this.pesquisa.produto) === -1 && [ '', null, undefined ].indexOf(this.pesquisa.produto.totais) === -1) {
                      this.pesquisa.produto.totais = totaisP
                    }
                    // VERIFICA SERVIÇO
                    if ([ '', null, undefined ].indexOf(this.pesquisa.servico) === -1 && [ '', null, undefined ].indexOf(this.pesquisa.servico.totais) === -1) {
                      this.pesquisa.servico.totais = totaisS
                    }
                  }
                }
              }, this.demRelPorItensSetarStatusGeral)
            }
          // }
        }, time)
      },
      demRelPorItensTratarDadosGrafico: function () {
        // OCULTA O GRAFICO
        if ([ '', null, undefined ].indexOf(this.grafico) === -1) {
          this.grafico.destroy()
        }

        // MOSTRA O GRAFICO
        this.grafico = ''

        // VERIFICA O TIPO DE REGISTRO
        switch (this.params.tipo) {
          case 'ticket_medio':
            this.demRelPorItensMontarGraficoTela(this.params.colunas, this.params.valores.valor_medio)
            break

          case 'venda_total':
            this.demRelPorItensMontarGraficoTela(this.params.colunas, this.params.valores.valor_tot)
            break

          case 'qtde_total':
            this.demRelPorItensMontarGraficoTela(this.params.colunas, this.params.valores.qtde)
            break
        }
      },
      demRelPorItensMontarGraficoTela: function (colunas, valores, tentativa = 0) {
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(() => { this.demRelPorItensMontarGraficoTela(colunas, valores, (tentativa + 1)) }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // CALCULAR O TAMANHO DO GRAFICO
          var tamanho = 500

          // MULTIPLICA O TAMANHO DE CADA BARRA PELA QUANTIDADE DE COLUNAS
          tamanho += (Object.keys(colunas).length * 25)

          // SETA O TAMANHO DO CAMPO
          this.tamanho = Number(window.innerWidth) >= tamanho ? '98%' : (tamanho.toString() + 'px')

          // FAZ A QUEBRA DE SINCRONISMO DO VUE
          setTimeout(() => {
            // IMPORTA A FUNÇÃO
            const Chart = require('chart.js')

            // INICIA A VARIAVEL
            var titulo = ''

            // VERIFICA O TITULO DO CAMPO
            switch (this.params.tipo) {
              case 'ticket_medio':
                titulo = 'Ticket Médio R$'
                break

              case 'venda_total':
                titulo = 'Valor Total R$'
                break

              case 'qtde_total':
                titulo = 'Quantidade'
                break
            }

            // SETA A ALTURA MAXIMA DO GRAFICO
            this.$refs.grafico.style.height = '400px'
    
            // SETA O GRAFICO NA TELA
            this.grafico = new Chart(this.$refs.grafico, {
              type: 'bar',
              data: {
                labels: Object.values(colunas),
                datasets: [ valores ]
              },
              options: {
                legend: {
                  display: false
                },
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        autoSkip: false,
                        maxRotation: 45,
                        minRotation: 45,
                        callback: function (val) {
                          // PEGAR PARTE DO NOME DO CONTATO
                          val = val.toUpperCase()
                          if (val.length >= 20) {
                            val = val.substring(0, 20) + '...'
                          }
                          
                          // RETORNA O VALOR MONTADO
                          return val
                        }
                      },
                      scaleLabel: {
                        display: false
                      }
                    }
                  ],
                  yAxes: [ 
                    {
                      scaleLabel: {
                        display: true,
                        labelString: titulo
                      },
                      ticks: {
                        beginAtZero: true,
                        callback: (label) => {
                          switch (this.params.tipo) {
                            case 'ticket_medio':
                            case 'venda_total':
                              return this.$store.state.FUN_MASK_VALOR('valorMoeda', (label * 100).toFixed(0).toString())

                            case 'qtde_total':
                              return this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', label.toString())
                          }
                        }
                      }
                    }
                  ]
                },
                tooltips: {
                  enabled: true,
                  mode: 'single',
                  callbacks: {
                    label: (item) => {
                      switch (this.params.tipo) {
                        case 'ticket_medio':
                          return 'Ticket Médio: R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())

                        case 'venda_total':
                          return 'Venda Total: R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', (item.value * 100).toFixed(0).toString())

                        case 'qtde_total':
                          return 'Quantidade: ' + this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', item.value.toString())
                      }
                    }
                  }
                }
              }
            })
          }, 0)
        }
      },
      demRelPorItensPesquisar: function () {
        // SETA O STATUS DE CARREGANDO
        this.pesquisa = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE AGUARDAR CARREGAMENTO
        if (this.filtros.dat !== '' && (typeof this.filtros.dat === 'string' || this.filtros.dat._dataIni === undefined)) {
          // return 
          setTimeout(() => { this.demRelPorItensPesquisar() }, 50)
        } else {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // INICIA AS VARIAVEIS
          var querys = {}

          // PEGA A MINHA PERSONALIZAÇÃO EXISTENTE
          this.tabper = this.$store.state.mPer[this.mper.tabper]
    
          // VERIFICA SE TEM ALGUMA PERSONALIZAÇÃO
          if (this.tabper.flag !== false) {
            // SETA AS COLUNAS MARCADAS
            for (var indexC in this.mper.fieldOptions) {
              // OCULTA TODAS AS COLUNAS OPCIONAIS
              if (this.mper.fieldOptions[indexC].mPer === 1) {
                this.mper.fieldOptions[indexC].mPer = 0
              }
    
              // VERIFICA SE A COLUNA DEVE SER APRESENTADA
              if (this.mper.fieldOptions[indexC].mPer === 0 && this.tabper.field.indexOf(this.mper.fieldOptions[indexC].chave) !== -1) {
                this.mper.fieldOptions[indexC].mPer = 1
              }
            }            
          }

          // SETA O VALOR RECEBIDO
          this.params.pag = Number(1)
          this.params.rpp = Number(this.tabper.rpp)

          // INICIA A VARIAVEL
          var pesquisa = []

          // VERIFICA A DEMANDA QUE ESTÁ TRABALHANDO
          if (this.cpntDemanda === 'venda') {
            // ADICIONA A BUSCA DO PRODUTO
            if (this.filtros.pro !== '__NENHUM__' && this.permissoes.pro === true) {
              pesquisa.push('venda_produto')
            }
  
            // ADICIONA A BUSCA DO PRODUTO
            if (this.filtros.ser !== '__NENHUM__' && this.permissoes.ser === true) {
              pesquisa.push('venda_servico')
            }
          } else {
            pesquisa.push('compra_produto')
          }

          // INICIA A VARIAVEL
          var chave = ''
          
          // INICIA O AGRUPAMENTO GRAFICO
          this.params.qtdeMes = null
          this.params.tipo = typeof this.campos.tp_grafico.value === 'string' ? this.campos.tp_grafico.value : this.campos.tp_grafico.value.id
          
          // MONTA A DATA INICIAL E FINAL DA PESQUISA
          if (this.filtros.dat !== '') {
            this.demRelPorItensMontarDataIniDataFimPesquisa(this.filtros.dat.dataIni, this.filtros.dat.dataFim)
          }

          // MONTA TODOS OS REQUESTS PARA API
          for (var indexP in pesquisa) { 
            // ADICIONA A PESQUISA MONTADA AO VETOR
            chave = pesquisa[indexP]
            querys[chave] = this.demRelPorItensMontarPesquisa(chave)
          }
  
          // FAZ A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/rota-multipla', 'POST', querys, (retorno) => {
            // FLAG DO ERRO
            var erro = false

            // JUNTA OS VALORES RECEBIDOS
            for (var index in retorno) {
              if (retorno[index].code !== '200') {
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno[index])

                // SETA O STATUS NA TELA
                this.demRelPorItensSetarStatusGeral(retorno[index])

                // SETA O FLAG QUE FOI IDENTIFICADO UM ERRO
                erro = true

                // PARA DE RODAR O VETOR
                break
              }
            }

            // VERIFICAR SE TEM ALGUM ERRO NA BUSCA
            if (erro === false) {
              this.demRelPorItensSetarTotais(retorno)
            }
          }, this.demRelPorItensSetarStatusGeral)
        }
      },
      demRelPorItensMontarDataIniDataFimPesquisa: function (dataIni, dataFim) {
        // VERIFICA SE TEM DATA INICIAL E NÃO TEM DATA FINAL
        if ([ '', null, undefined, NaN ].indexOf(dataIni) === -1 && [ '', null, undefined, NaN ].indexOf(dataFim) !== -1) {
          dataFim = dataIni
        }

        // CALCULA A DIFERENÇA DE MESES
        this.params.qtdeMes = Math.ceil(moment(dataFim, 'DD/MM/YYYY').diff(moment(dataIni, 'DD/MM/YYYY'), 'months', true))

        // SETA A DATA INICIAL
        this.params.dataIni = dataIni

        // SETA A DATA INICIAL
        this.params.dataFim = dataFim
      },
      demRelPorItensMontarQueryGet: function (pag, rpp, tipo) {
        return new Promise((success) => {
          // MONTA O NOME DA DEMANDA
          var demanda = this.cpntDemanda + '_' + tipo

          // SETA O VALOR RECEBIDO
          this.params.pag = Number(pag)
          this.params.rpp = Number(rpp)

          // MONTA O REQUEST
          var pesquisa = this.demRelPorItensMontarPesquisa(demanda, pag, rpp)

          // FINALIZA O PROCESSO DE CARREGAMENTO
          success(pesquisa.parametro)
        })
      },
      demRelPorItensMontarPesquisa: function (chave, pag = 0, rpp = this.tabper.rpp) {
        // INICIA A VARIAVEL
        var pesquisa = { rota: this.demRelPorItensMontarRouter(chave), metodo: this.demRelPorItensMontarMethod(chave) }

        // SETA O LIMITE PARA BUSCA
        var row = ((pag * rpp) - rpp)

        // VERIFICA SE O NUMERO É NEGATIVO
        if (row < 0) {
          row = 0
        }

        // VERIFICA A DEMANDA QUE DEVE MONTAR
        switch (chave) {
          case 'compra_produto':
          case 'compra_produto_grafico':
          case 'venda_produto':
          case 'venda_produto_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: row, qty: rpp } }
            
            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.demRelPorItensMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field_virtual = this.demRelPorItensMontarFieldVirtual(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.demRelPorItensMontarWhere(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.order = this.demRelPorItensMontarOrder(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ 'id_pro' ]
            break

          case 'venda_servico':
          case 'venda_servico_grafico':
            // INICIA O QUERYGET
            pesquisa.parametro = { type: 'list', limit: { row: row, qty: rpp } }
            
            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field = this.demRelPorItensMontarField(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.field_virtual = this.demRelPorItensMontarFieldVirtual(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.where = this.demRelPorItensMontarWhere(chave)

            // MONTA O WHERE QUE SERÁ REALIZADO
            pesquisa.parametro.order = this.demRelPorItensMontarOrder(chave)

            // SETA A CHAVE GROUP
            pesquisa.parametro.group = [ 'id_ser' ]
            break
        }

        // RETORNA O VALOR MONTADO
        return JSON.parse(JSON.stringify(pesquisa))
      },
      demRelPorItensAlterarGrafico: function (value) {
        // SETA O VALOR RECEBIDO
        this.campos.tp_grafico.value = value

        // SETA O TIPO DO GRAFICO QUE DEVE SER CARREGADO
        this.params.tipo = this.campos.tp_grafico.value === true ? 'valor' : 'qtde'
        
        // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO NA TELA
        this.demRelPorItensMontarGraficoDados()
      }
    },
    computed: {
      demRelPorItensContarColunasLinha1: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 1

        // VERIFICA SE TEM O PACOTE VEICULO
        qtde = (qtde + (this.permissoes.vei === true ? 1 : 0))

        // VERIFICA SE TEM O PACOTE PET
        qtde = (qtde + (this.permissoes.pet === true ? 1 : 0))

        // RETORNA O VALOR
        return qtde
      },
      demRelMaisUtiQtdeRegistro: function () {
        // INICIA A CONTA DE COLUNAS
        var qtde = 0

        // VERIFICA SE TEM REGISTRO
        if ([ '', null, undefined ].indexOf(this.pesquisa.produto) === -1) {
          // VERIFICA SE TEM REGISTRO PRODUTO
          qtde += [ '', null, undefined ].indexOf(this.pesquisa.produto) === -1 ? Number(this.pesquisa.produto.countAll) : 0

          // VERIFICA SE TEM REGISTRO SERVIÇO
          qtde += [ '', null, undefined ].indexOf(this.pesquisa.servico) === -1 ? Number(this.pesquisa.servico.countAll) : 0
        }

        // RETORNA O VALOR
        return qtde
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== routeAtual.name) {
          // SETA O STATUS DA PAGINA
          this.demRelPorItensSetarStatusGeral('carregando')

          // LIMPA AS VARIAVEIS
          this.tabper = {}
          this.mper.tabper = ''

          // FAZ A VERIFICAÇÃO DAS PERMISSÕES DO USUARIO
          this.demRelPorItensVerificarPermissao()

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.demRelPorItensIniciar() }, 500)
        }
      }
    }
  }
</script>
